(function () {

  // ====== 1. 全局进度条更新函数 ======
  window.updateCartProgressBar = function (itemCount, cartTotal, currencyCode) {
    const fill = document.getElementById('cpb-fill');
    const message = document.getElementById('cpb-message');

    if (!fill || !message) return;

    // 美金基础包邮门槛 $99.00
    const BASE_USD_THRESHOLD = 99.00; 

    // 获取当前 Shopify 汇率 (默认为 1.0)
    const rate = (window.Shopify && Shopify.currency && Shopify.currency.rate)
      ? parseFloat(Shopify.currency.rate)
      : 1.0;

    // 当前币种下的实际包邮门槛 (例如: 99 USD * 10.5 汇率 = 1039.5 SEK)
    const currentThreshold = BASE_USD_THRESHOLD * rate;

    // 获取当前 active 货币代码 (默认 USD)
    const activeCurrency = currencyCode || 
      (window.Shopify && Shopify.currency && Shopify.currency.active) || 
      'USD';

    // 进度条计算 (最高 100%)
    const progress = Math.min((cartTotal / currentThreshold) * 100, 100);
    fill.style.width = progress + '%';

    // 货币自动格式化器 (原生支持 SEK / EUR / GBP / AUD / USD / JPY 等全球货币)
    const formatter = new Intl.NumberFormat(
      (window.Shopify && Shopify.locale) ? Shopify.locale : 'en-US', 
      {
        style: 'currency',
        currency: activeCurrency
      }
    );

    // 动态文案渲染
    let html = '';

    if (itemCount === 0 || cartTotal === 0) {
      html = `🛒 Add items to unlock <strong>Free Shipping</strong>!`;
    } else if (cartTotal < currentThreshold) {
      const remaining = currentThreshold - cartTotal;
      const remainingFormatted = formatter.format(remaining);
      html = `You're <strong>${remainingFormatted}</strong> away from <strong>Free Shipping</strong>.`;
    } else {
      html = `🎉 <strong>Free Shipping</strong> unlocked!`;
    }

    // 切换动画
    message.style.opacity = '0';
    setTimeout(() => {
      message.innerHTML = html;
      message.style.opacity = '1';
    }, 200);
  };

  // ====== 2. 全球货币 DOM 价格解析函数 ======
  function getPriceFromDOM() {
    // 优先从包含 data-total-price (cents) 的节点直接读取纯数字（如果 Liquid 有传）
    const dataPriceElem = document.querySelector('[data-total-price]');
    if (dataPriceElem && dataPriceElem.dataset.totalPrice) {
      const cents = parseFloat(dataPriceElem.dataset.totalPrice);
      if (!isNaN(cents)) return cents / 100;
    }

    // 否则从 DOM 渲染的文本中提取价格
    const priceElement = document.querySelector('.cart-drawer__subtotal--sale') || 
                         document.querySelector('.cart-drawer__subtotal--price');
    
    if (priceElement) {
      let priceText = (priceElement.innerText || priceElement.textContent).trim();
      
      // A. 清理不间断空格 (\u00A0) 及普通空格（解决 SEK 1 250,00 kr / EUR 1 250,00 €）
      priceText = priceText.replace(/[\s\u00A0]/g, '');

      // B. 判断是否为逗号作小数点的货币（例如 "95,00kr" / "1250,00€" / "95,00"）
      // 正则含义：逗号后面跟着恰好 2 位数字，且后面不再紧跟数字
      const isCommaDecimal = /,\d{2}(?!\d)/.test(priceText);

      if (isCommaDecimal) {
        // 去掉作千分位的点 .，把作小数点的逗号 , 替换成点 .
        priceText = priceText.replace(/\./g, '').replace(',', '.');
      } else {
        // 去掉作千分位的逗号 ,
        priceText = priceText.replace(/,/g, '');
      }

      // C. 提取纯数字和小数点
      const cleanedPrice = priceText.replace(/[^0-9.]/g, '');
      const parsedPrice = parseFloat(cleanedPrice);
      
      if (!isNaN(parsedPrice)) {
        return parsedPrice; 
      }
    }
    return null;
  }

  // ====== 3. 刷新与数据请求 ======
  function refreshCartData() {
    // 延迟 300ms 等待 Ajax Cart Drawer DOM 渲染完成
    setTimeout(() => {
      const domPrice = getPriceFromDOM();
      const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      
      fetch(rootPath + 'cart.js')
        .then(res => res.json())
        .then(cart => {
          const apiTotal = cart.total_price / 100;
          let finalTotal = apiTotal;

          // 防解析异常锁：如果 DOM 解析出的数值合理（非 null 且未出现夸张的数量级偏差），优先使用 DOM 最终售价；否则使用 cart.js 的 API 兜底
          if (domPrice !== null && domPrice < apiTotal * 5) {
            finalTotal = domPrice;
          }
          
          window.updateCartProgressBar(cart.item_count, finalTotal, cart.currency);
        })
        .catch(console.error);
    }, 300);
  }

  // ====== 4. 拦截 Fetch 请求 ======
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(response => {
      const url = response.url || '';
      if (
        url.includes('/cart/add') ||
        url.includes('/cart/update') ||
        url.includes('/cart/change') ||
        url.includes('/cart/clear')
      ) {
        refreshCartData();
      }
      return response;
    });
  };

  // ====== 5. 事件初始化与监听 ======
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCartData);
  } else {
    refreshCartData();
  }

  document.addEventListener('cart:updated', refreshCartData);
  document.addEventListener('cart:refresh', refreshCartData);

})();